import React from 'react';
import {Redirect, Route, RouteComponentProps, Switch, useRouteMatch} from 'react-router-dom';
import {ForecastQueryRenderer} from '../../../ForecastQueryRenderer';
import {TemplatesPage} from './TemplatesPage';
import {BaselineTemplatesPage, BaselineTemplatesPageQuery} from './baseline/BaselineTemplatesPage';
import {CreateBaselineTemplatePage, CreateBaselineTemplatePageQuery} from './baseline/create/CreateBaselineTemplatePage';
import {EditBaselineTemplatePage, EditBaselineTemplatePageQuery} from './baseline/edit/EditBaselineTemplatePage';

const TemplatesRoutes = (): JSX.Element => {
	const {path} = useRouteMatch();
	return (
		<Switch>
			<Route exact path={`${path}/baseline/new`}>
				<ForecastQueryRenderer
					key="query-render-CreateBaselineTemplatePage"
					query={CreateBaselineTemplatePageQuery}
					authorizeAccessRoute={'settings'}
					render={(relayProps: React.ComponentProps<typeof CreateBaselineTemplatePage>) => (
						<TemplatesPage showTabs={false}>
							<CreateBaselineTemplatePage {...relayProps} />
						</TemplatesPage>
					)}
				/>
			</Route>
			<Route
				exact
				path={`${path}/baseline/:id/edit`}
				render={({match}: RouteComponentProps<{id: string}>) => {
					// The path carries the global id encoded; see editBaselineTemplatePath. A hand-typed id that
					// does not decode names no template.
					let templateId: string;
					try {
						templateId = decodeURIComponent(match.params.id);
					} catch {
						return <Redirect to="/not-found" />;
					}
					return (
						<ForecastQueryRenderer
							key={`query-render-EditBaselineTemplatePage-${templateId}`}
							query={EditBaselineTemplatePageQuery}
							variables={{id: templateId}}
							// The form is seeded once from the first render, so it must be the stored template: a
							// cached copy from before a save would be saved back over it.
							fetchPolicy="network-only"
							authorizeAccessRoute={'settings'}
							render={(relayProps: React.ComponentProps<typeof EditBaselineTemplatePage>) => (
								<TemplatesPage showTabs={false}>
									<EditBaselineTemplatePage {...relayProps} templateId={templateId} />
								</TemplatesPage>
							)}
						/>
					);
				}}
			/>
			<Route exact path={`${path}/baseline`}>
				<ForecastQueryRenderer
					key="query-render-BaselineTemplatesPage"
					query={BaselineTemplatesPageQuery}
					authorizeAccessRoute={'settings'}
					render={(relayProps: React.ComponentProps<typeof BaselineTemplatesPage>) => (
						<TemplatesPage showTabs>
							<BaselineTemplatesPage {...relayProps} />
						</TemplatesPage>
					)}
				/>
			</Route>
			<Redirect to={`${path}/baseline`} />
		</Switch>
	);
};

export default TemplatesRoutes;
